/**
 * Dashboard
 */

import React, { Component, Fragment } from 'react'
import { Alert } from 'reactstrap';
import { Helmet } from "react-helmet";
import { Redirect, Route, Switch, Link } from 'react-router-dom';
import { Form, FormGroup, Input } from 'reactstrap';
import FormControl from '@material-ui/core/FormControl';
import MatButton from '@material-ui/core/Button';
// intl messages
import IntlMessages from 'Util/IntlMessages';
import Button from '@material-ui/core/Button';
import Calendar from "react-calendar";
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { format, parseISO, addHours, startOfWeek, endOfWeek} from 'date-fns';
import "react-calendar/dist/Calendar.css";
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import { NotificationManager } from 'react-notifications';
// app config
import { connect } from 'react-redux';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';

// rct collapsible card
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';
// rct section loader
import RctSectionLoader from 'Components/RctSectionLoader/RctSectionLoader';
import { RctCard, RctCardContent } from 'Components/RctCard';
import { DateTimePicker, DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { es } from "date-fns/locale";
import DateFnsUtils from '@date-io/date-fns'; // choose your lib
import esLocale from "date-fns/locale/es";

import {
	VisitorAreaChartWidget,
	SalesAreaChartWidget,
	OrdersAreaChartWidget,
	RecentOrdersWidget,
	SupportRequest,
	Notifications,
	TopSellingWidget,
	OverallTrafficStatusWidget,
	ProductReportsWidget,
	OnlineVisitorsWidget,
	TodayOrdersStatsWidget,
	BookingInfo,
	NewOrderCountdown,
	FollowersWidget,
	Notes
} from "Components/Widgets";

// widgets data
import {
	visitorsData,
	salesData,
	ordersData,
	topSellingProducts,
	trafficStatus,
} from './data';

import axios from "axios";

import { Bar, Line } from 'react-chartjs-2';
import ChartConfig from 'Constants/chart-config';
import { Badge } from 'reactstrap';
import MatBadge from '@material-ui/core/Badge';
import { Chart as ChartJS, LineElement, PointElement, LineController, CategoryScale, LinearScale, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
  LineController,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  ChartDataLabels
);

class Dashboard extends Component {
        
        constructor(props) {
            
        const today = new Date();
        const start = startOfWeek(today, { weekStartsOn: 1 }); // lunes
        const end = endOfWeek(today, { weekStartsOn: 1 });     // domingo
      
        super(props);
            this.state = {
              ready: true,
              visible: true,
              loading: true,
              loadingGrafico2 : true,
              loadingGrafico1 : false,
              selectedDate: new Date(),
              //selectedDate_chofer: new Date(),
              last_activity: '',
              activeEnex : '',
              activeEsmax : '',
              activeEnex2 : '',
              activeEsmax2 : 'line-through',
             dataLineActivosEnex:'',
             dataLineActivosEnex2:'',
             totalEnex2: 0,
             totalEnex: 0,
             totalEnex2Mask: 0,
             totalEnexMask: 0,
             totalEnexFinal: 0,
             totalEsmax2: 0,
             totalEsmax: 0,
             totalEsmaxFinal: 0,
             dataLineDiasEnex : 0,
             dataLineDiasEsmax : 0,
              maxDate : new Date(),
              minDate: new Date(2024, 8, new Date().getDate()),
              myRol : '',
              DataLubricante:[],
              DataCombustible:[],
              DataDias:[],
              
              activeEnex_chofer : '',
              activeEsmax_chofer : '',
              activeEnex2_chofer : '',
              activeEsmax2_chofer : 'line-through',
             dataLineActivosEnex_chofer:'',
             dataLineActivosEnex2_chofer:'',
             totalEnex2_chofer: 0,
             totalEnex_chofer: 0,
             totalEnex2Mask_chofer: 0,
             totalEnexMask_chofer: 0,
             totalEnexFinal_chofer: 0,
             totalEsmax2_chofer: 0,
             totalEsmax_chofer: 0,
             totalEsmaxFinal_chofer: 0,
             dataLineDiasEnex_chofer : 0,
             dataLineDiasEsmax_chofer : 0,
             DataLubricante_chofer:[],
             DataCombustible_chofer:[],
             DataDias_chofer:[],
             maxDate_chofer : new Date(),
             minDate_chofer: new Date(2024, 8, new Date().getDate()),
             selectedDate_chofer: today,
             weekRange: [start, end],
             openCalendar: false
            };
            this.onDismiss = this.onDismiss.bind(this);
        };
        
        onDismiss() {
            this.setState({ visible: false });
         }
         
         cambiaData2(e, string){
             e.preventDefault();
             
             let dataLineNuevos = [];
             let dataLineDias = [];
             let dataLineActivos = [];

             let activeEnex2 = this.state.activeEnex2;
             let activeEsmax2 = this.state.activeEsmax2;
             
              if (string == 'ENEX') {
                
                if(this.state.activeEnex2 === ''){
                    activeEnex2 = 'line-through';
                } else {
                    activeEnex2 = '';
                }
                
                activeEsmax2 = 'line-through';
    
            }else if(string == 'ESMAX'){
                 
                if(this.state.activeEsmax2 === ''){
                    activeEsmax2 = 'line-through';
                } else {
                    activeEsmax2 = '';
                }
                activeEnex2 = 'line-through';
            }
        
            if(activeEnex2 == ''){//activar enex
                
                this.setState({ 
                  activeEnex2:activeEnex2,
                  activeEsmax2:activeEsmax2,
                  DataDias: this.state.dataLineDiasEnex,
                  DataCombustible : this.state.dataLineActivosEnex,
                  DataLubricante: this.state.dataLineActivosEnex2,
                  totalEnexMask:this.state.totalEnex,
                  totalEnex2Mask:this.state.totalEnex2,
                 });
                
            }else if(activeEsmax2 == ''){//activar esmax
               
                this.setState({ 
                  activeEnex2:activeEnex2,
                  activeEsmax2:activeEsmax2,
                  DataDias: this.state.dataLineDiasEsmax,
                  DataCombustible : this.state.dataLineActivosEsmax,
                  DataLubricante: this.state.dataLineActivosEsmax2,
                  totalEnexMask:this.state.totalEsmax,
                  totalEnex2Mask:this.state.totalEsmax2,
                 });
            } 

         }
         
        handleOpenCalendar = () => this.setState({ openCalendar: true });
        handleCloseCalendar = () => this.setState({ openCalendar: false });

        // cuando selecciona un día en el calendario
        handleChangeCalendar = (date) => {
          const start = startOfWeek(date, { weekStartsOn: 1 });
          const end = endOfWeek(date, { weekStartsOn: 1 });
          this.setState({
            selectedDate_chofer: date,
            weekRange: [start, end],
            openCalendar: false, // cerrar modal automáticamente,
            loadingGrafico1: true
          });
          
         // this.setState({ loadingGrafico1: true});

            //const { selectedDate_chofer } = this.state;
            //console.log(selectedDate_chofer);return;
            //let month = (selectedDate_chofer.getMonth() + 1).toString().padStart(2, "0"); 
           // let year = selectedDate_chofer.getUTCFullYear();
            
            const primerDiaSemana = format(
                startOfWeek(date, { weekStartsOn: 1 }),
                "yyyy-MM-dd"
              );

            axios.get('/checklist/graphic-checklist-chofer/'+primerDiaSemana, {}).then((response) => {
            if(response.data && response.data.dia){

                 let dataLineDiasEnex_chofer = [];
                 let dataLineActivosEnex_chofer = [];
                 let dataLineActivosEnex2_chofer = [];      

                 let dataLineDiasEsmax_chofer = [];
                 let dataLineActivosEsmax_chofer = [];
                 let dataLineActivosEsmax2_chofer = [];      

                 for(let i=0;i<response.data.dia.length;i++){
                     dataLineDiasEnex_chofer.push(response.data.dia[i]);
                     dataLineActivosEnex_chofer.push(response.data.activasEnex[i]);
                     dataLineActivosEnex2_chofer.push(response.data.activasEnex2[i]);
                 }

                 for(let i=0;i<response.data.diamax.length;i++){
                     dataLineDiasEsmax_chofer.push(response.data.diamax[i]);
                     dataLineActivosEsmax_chofer.push(response.data.activasEsmax[i]);
                     dataLineActivosEsmax2_chofer.push(response.data.activasEsmax2[i]);
                 }

                 this.setState({ loadingGrafico1 : false,
                     dataLineActivosEnex_chofer:dataLineActivosEnex_chofer,
                     dataLineActivosEsmax_chofer:dataLineActivosEsmax_chofer,

                     dataLineActivosEnex2_chofer:dataLineActivosEnex2_chofer,
                     dataLineActivosEsmax2_chofer:dataLineActivosEsmax2_chofer,

                     totalEnex2_chofer: response.data.totalEnex2,
                     totalEsmax2_chofer: response.data.totalEsmax2,

                     totalEnex_chofer: response.data.totalEnex,
                     totalEsmax_chofer: response.data.totalEsmax,

                     totalEnexFinal_chofer: response.data.totalEnex2 + response.data.totalEnex,
                     totalEsmaxFinal_chofer: response.data.totalEsmax2 + response.data.totalEsmax,

                     dataLineDiasEnex_chofer : dataLineDiasEnex_chofer,
                     dataLineDiasEsmax_chofer : dataLineDiasEsmax_chofer,
                     activeEsmax2_chofer : 'line-through',
                     activeEnex2_chofer : '',
                     DataDias_chofer: dataLineDiasEnex_chofer,
                     DataCombustible_chofer : dataLineActivosEnex_chofer,
                     DataLubricante_chofer: dataLineActivosEnex2_chofer,
                     totalEnexMask_chofer:response.data.totalEnex,
                     totalEnex2Mask_chofer:response.data.totalEnex2

                 });
            } else {
                this.setState({ loadingGrafico1 : false});  
            }
          }, (error) => {
              console.log(error);
              this.setState({ loadingGrafico1 : false});
          });
          
        };
         
         cambiaData2_chofer(e, string){
             e.preventDefault();
             
             let dataLineNuevos_chofer = [];
             let dataLineDias_chofer = [];
             let dataLineActivos_chofer = [];

             let activeEnex2_chofer = this.state.activeEnex2_chofer;
             let activeEsmax2_chofer = this.state.activeEsmax2_chofer;
             
              if (string == 'ENEX') {
                
                if(this.state.activeEnex2_chofer === ''){
                    activeEnex2_chofer = 'line-through';
                } else {
                    activeEnex2_chofer = '';
                }
                
                activeEsmax2_chofer = 'line-through';
    
            }else if(string == 'ESMAX'){
                 
                if(this.state.activeEsmax2_chofer === ''){
                    activeEsmax2_chofer = 'line-through';
                } else {
                    activeEsmax2_chofer = '';
                }
                activeEnex2_chofer = 'line-through';
            }
        
            if(activeEnex2_chofer == ''){//activar enex
                
                this.setState({ 
                  activeEnex2_chofer:activeEnex2_chofer,
                  activeEsmax2_chofer:activeEsmax2_chofer,
                  DataDias_chofer: this.state.dataLineDiasEnex_chofer,
                  DataCombustible_chofer : this.state.dataLineActivosEnex_chofer,
                  DataLubricante_chofer: this.state.dataLineActivosEnex2_chofer,
                  totalEnexMask_chofer:this.state.totalEnex_chofer,
                  totalEnex2Mask_chofer:this.state.totalEnex2_chofer,
                 });
                
            }else if(activeEsmax2_chofer == ''){//activar esmax
            
                this.setState({ 
                  activeEnex2_chofer:activeEnex2_chofer,
                  activeEsmax2_chofer:activeEsmax2_chofer,
                  DataDias_chofer: this.state.dataLineDiasEsmax_chofer,
                  DataCombustible_chofer : this.state.dataLineActivosEsmax_chofer,
                  DataLubricante_chofer: this.state.dataLineActivosEsmax2_chofer,
                  totalEnexMask_chofer:this.state.totalEsmax_chofer,
                  totalEnex2Mask_chofer:this.state.totalEsmax2_chofer,
                 });
            } 

         }
   
         componentWillMount() {

            const { location, history, darkMode} = this.props;
            
            axios.get('/checkloggin', {}).then((response) => {
              if(!response.data){
                  if (localStorage.getItem("user_id") !== null) {
                        localStorage.removeItem('user_id');
                        localStorage.removeItem('name');
                        localStorage.removeItem('email');
                        localStorage.removeItem('rol');
                        localStorage.removeItem('rut');
                        history.push('/signin');
                        NotificationManager.error('¡Se ha perdido la sesión!');
                    }
              } else {
                  this.setState({ myRol:response.data.rol});
                  this.Init();
              }
            }, (error) => {
                console.log(error);

            });

        }
        
        onrefreshGraph2 = (e) => {
             e.preventDefault();
             this.setState({ loadingGrafico2: true });
             
             const { selectedDate } = this.state;

            let month = (selectedDate.getMonth() + 1).toString().padStart(2, "0"); 
            let year = selectedDate.getUTCFullYear();

             axios.get('/checklist/graphic-checklist/'+year+'-'+month, {}).then((response) => {
                   if(response.data && response.data.dia){

                        let dataLineDiasEnex = [];
                        let dataLineActivosEnex = [];
                        let dataLineActivosEnex2 = [];      
                        
                        let dataLineDiasEsmax = [];
                        let dataLineActivosEsmax = [];
                        let dataLineActivosEsmax2 = [];      

                        for(let i=0;i<response.data.dia.length;i++){
                            dataLineDiasEnex.push(response.data.dia[i]);
                            dataLineActivosEnex.push(response.data.activasEnex[i]);
                            dataLineActivosEnex2.push(response.data.activasEnex2[i]);
                        }
                        
                        for(let i=0;i<response.data.diamax.length;i++){
                            dataLineDiasEsmax.push(response.data.diamax[i]);
                            dataLineActivosEsmax.push(response.data.activasEsmax[i]);
                            dataLineActivosEsmax2.push(response.data.activasEsmax2[i]);
                        }

                        this.setState({ loadingGrafico2 : false,
                            dataLineActivosEnex:dataLineActivosEnex,
                            dataLineActivosEsmax:dataLineActivosEsmax,
                            
                            dataLineActivosEnex2:dataLineActivosEnex2,
                            dataLineActivosEsmax2:dataLineActivosEsmax2,
                            
                            totalEnex2: response.data.totalEnex2,
                            totalEsmax2: response.data.totalEsmax2,
                            
                            totalEnex: response.data.totalEnex,
                            totalEsmax: response.data.totalEsmax,
                            
                            totalEnexFinal: response.data.totalEnex2+response.data.totalEnex,
                            totalEsmaxFinal: response.data.totalEsmax2+response.data.totalEsmax,
                            
                            dataLineDiasEnex : dataLineDiasEnex,
                            dataLineDiasEsmax : dataLineDiasEsmax,
                            activeEsmax2 : 'line-through',
                            activeEnex2 : '',
                            DataDias: dataLineDiasEnex,
                            DataCombustible : dataLineActivosEnex,
                            DataLubricante: dataLineActivosEnex2,
                            totalEnexMask:response.data.totalEnex,
                            totalEnex2Mask:response.data.totalEnex2
                            
                        });
                   } else {
                       this.setState({ loadingGrafico2 : false});  
                   }
                 }, (error) => {
                     console.log(error);
                     this.setState({ loadingGrafico2 : false});
                 });
        }
        
        onrefreshGraph2_chofer = (e) => {
             e.preventDefault();
             this.setState({ loadingGrafico1: true});

             // const { selectedDate_chofer } = this.state;

               const primerDiaSemana = format(
                startOfWeek(this.state.selectedDate_chofer, { weekStartsOn: 1 }),
                "yyyy-MM-dd"
              );
      
            //let month = (selectedDate_chofer.getMonth() + 1).toString().padStart(2, "0"); 
            //let year = selectedDate_chofer.getUTCFullYear();

             axios.get('/checklist/graphic-checklist-chofer/'+primerDiaSemana, {}).then((response) => {
                   if(response.data && response.data.dia){

                        let dataLineDiasEnex_chofer = [];
                        let dataLineActivosEnex_chofer = [];
                        let dataLineActivosEnex2_chofer = [];      
                        
                        let dataLineDiasEsmax_chofer = [];
                        let dataLineActivosEsmax_chofer = [];
                        let dataLineActivosEsmax2_chofer = [];      

                        for(let i=0;i<response.data.dia.length;i++){
                            dataLineDiasEnex_chofer.push(response.data.dia[i]);
                            dataLineActivosEnex_chofer.push(response.data.activasEnex[i]);
                            dataLineActivosEnex2_chofer.push(response.data.activasEnex2[i]);
                        }
                        
                        for(let i=0;i<response.data.diamax.length;i++){
                            dataLineDiasEsmax_chofer.push(response.data.diamax[i]);
                            dataLineActivosEsmax_chofer.push(response.data.activasEsmax[i]);
                            dataLineActivosEsmax2_chofer.push(response.data.activasEsmax2[i]);
                        }
                   
                        this.setState({ loadingGrafico1 : false,
                            dataLineActivosEnex_chofer:dataLineActivosEnex_chofer,
                            dataLineActivosEsmax_chofer:dataLineActivosEsmax_chofer,
                            
                            dataLineActivosEnex2_chofer:dataLineActivosEnex2_chofer,
                            dataLineActivosEsmax2_chofer:dataLineActivosEsmax2_chofer,
                            
                            totalEnex2_chofer: response.data.totalEnex2,
                            totalEsmax2_chofer: response.data.totalEsmax2,
                            
                            totalEnex_chofer: response.data.totalEnex,
                            totalEsmax_chofer: response.data.totalEsmax,
            
                            totalEnexFinal_chofer: response.data.totalEnex2 + response.data.totalEnex,
                            totalEsmaxFinal_chofer: response.data.totalEsmax2 + response.data.totalEsmax,
                            
                            dataLineDiasEnex_chofer : dataLineDiasEnex_chofer,
                            dataLineDiasEsmax_chofer : dataLineDiasEsmax_chofer,
                            activeEsmax2_chofer : 'line-through',
                            activeEnex2_chofer : '',
                            DataDias_chofer: dataLineDiasEnex_chofer,
                            DataCombustible_chofer : dataLineActivosEnex_chofer,
                            DataLubricante_chofer: dataLineActivosEnex2_chofer,
                            totalEnexMask_chofer:response.data.totalEnex,
                            totalEnex2Mask_chofer:response.data.totalEnex2
                            
                        });
                   } else {
                       this.setState({ loadingGrafico1 : false});  
                   }
                 }, (error) => {
                     console.log(error);
                     this.setState({ loadingGrafico1 : false});
                 });
        }
        
        handleDateChange = (date) => {
            this.setState({ selectedDate: date, loadingGrafico2: true });
            var month = (date.getMonth() + 1).toString().padStart(2, "0"); 
            var year = date.getUTCFullYear();
   
            axios.get('/checklist/graphic-checklist/'+year+'-'+month, {}).then((response) => {
                if(response.data && response.data.dia){

                     let dataLineDiasEnex = [];
                     let dataLineActivosEnex = [];
                     let dataLineActivosEnex2 = [];
                     
                    let dataLineDiasEsmax = [];
                    let dataLineActivosEsmax = [];
                    let dataLineActivosEsmax2 = [];    

                     for(let i=0;i<response.data.dia.length;i++){

                         dataLineDiasEnex.push(response.data.dia[i]);
                         dataLineActivosEnex.push(response.data.activasEnex[i]);
                         dataLineActivosEnex2.push(response.data.activasEnex2[i]);

                     }
                     
                     for(let i=0;i<response.data.diamax.length;i++){
                        dataLineDiasEsmax.push(response.data.diamax[i]);
                        dataLineActivosEsmax.push(response.data.activasEsmax[i]);
                        dataLineActivosEsmax2.push(response.data.activasEsmax2[i]);
                    }
                     
                     this.setState({ loadingGrafico2 : false,

                        dataLineActivosEnex:dataLineActivosEnex,
                        dataLineActivosEsmax:dataLineActivosEsmax,

                        dataLineActivosEnex2:dataLineActivosEnex2,
                        dataLineActivosEsmax2:dataLineActivosEsmax2,

                        totalEnex2: response.data.totalEnex2,
                        totalEsmax2: response.data.totalEsmax2,

                        totalEnex: response.data.totalEnex,
                        totalEsmax: response.data.totalEsmax,

                        totalEnexFinal: response.data.totalEnex2+response.data.totalEnex,
                        totalEsmaxFinal: response.data.totalEsmax2+response.data.totalEsmax,

                        dataLineDiasEnex : dataLineDiasEnex,
                        dataLineDiasEsmax : dataLineDiasEsmax,
                        
                        DataDias: dataLineDiasEnex,
                        DataCombustible : dataLineActivosEnex,
                        DataLubricante: dataLineActivosEnex2,
                        totalEnex2: response.data.totalEnex2,
                        totalEnex: response.data.totalEnex,
                        
                        activeEsmax2 : 'line-through',
                        activeEnex2 : '',
                        totalEnexMask:response.data.totalEnex,
                        totalEnex2Mask:response.data.totalEnex2
                        
                     });
                } else {
                    this.setState({ loadingGrafico2 : false});  
                }
              }, (error) => {
                  console.log(error);
                  this.setState({ loadingGrafico2 : false});
              });
        };
        
        handleDateChangeChofer = (date) => {
            this.setState({ selectedDate_chofer: date, loadingGrafico1: true });
            //var month = (date.getMonth() + 1).toString().padStart(2, "0"); 
            //var year = date.getUTCFullYear();
            const primerDiaSemana = format(
                startOfWeek(date, { weekStartsOn: 1 }),
                "yyyy-MM-dd"
              );
   
            axios.get('/checklist/graphic-checklist-chofer/'+primerDiaSemana, {}).then((response) => {
                if(response.data && response.data.dia){

                     let dataLineDiasEnex_chofer = [];
                     let dataLineActivosEnex_chofer = [];
                     let dataLineActivosEnex2_chofer = [];
                     
                    let dataLineDiasEsmax_chofer = [];
                    let dataLineActivosEsmax_chofer = [];
                    let dataLineActivosEsmax2_chofer = [];    

                     for(let i=0;i<response.data.dia.length;i++){

                         dataLineDiasEnex_chofer.push(response.data.dia[i]);
                         dataLineActivosEnex_chofer.push(response.data.activasEnex[i]);
                         dataLineActivosEnex2_chofer.push(response.data.activasEnex2[i]);

                     }
                     
                     for(let i=0;i<response.data.diamax.length;i++){
                        dataLineDiasEsmax_chofer.push(response.data.diamax[i]);
                        dataLineActivosEsmax_chofer.push(response.data.activasEsmax[i]);
                        dataLineActivosEsmax2_chofer.push(response.data.activasEsmax2[i]);
                    }
                     
                     this.setState({ loadingGrafico1 : false,

                        dataLineActivosEnex_chofer:dataLineActivosEnex_chofer,
                        dataLineActivosEsmax_chofer:dataLineActivosEsmax_chofer,

                        dataLineActivosEnex2_chofer:dataLineActivosEnex2_chofer,
                        dataLineActivosEsmax2_chofer:dataLineActivosEsmax2_chofer,

                        totalEnex2_chofer: response.data.totalEnex2,
                        totalEsmax2_chofer: response.data.totalEsmax2,

                        totalEnex_chofer: response.data.totalEnex,
                        totalEsmax_chofer: response.data.totalEsmax,

                        totalEnexFinal_chofer: response.data.totalEnex2+response.data.totalEnex,
                        totalEsmaxFinal_chofer: response.data.totalEsmax2+response.data.totalEsmax,

                        dataLineDiasEnex_chofer : dataLineDiasEnex_chofer,
                        dataLineDiasEsmax_chofer : dataLineDiasEsmax_chofer,
                        
                        DataDias_chofer: dataLineDiasEnex_chofer,
                        DataCombustible_chofer : dataLineActivosEnex_chofer,
                        DataLubricante_chofer: dataLineActivosEnex2_chofer,
                        totalEnex2_chofer: response.data.totalEnex2,
                        totalEnex_chofer: response.data.totalEnex,
                        
                        activeEsmax2_chofer : 'line-through',
                        activeEnex2_chofer : '',
                        totalEnexMask_chofer:response.data.totalEnex,
                        totalEnex2Mask_chofer:response.data.totalEnex2
                        
                     });
                } else {
                    this.setState({ loadingGrafico1 : false});  
                }
              }, (error) => {
                  console.log(error);
                  this.setState({ loadingGrafico1 : false});
              });
        };
        
        Init(){
            
            this.setState({ loading:true });

            axios.get(`/users/last-activity`)
               .then(res => new Promise(resolve => setTimeout(() => resolve( 
             this.setState({ loading:false, last_activity : res.data[0].last_active_at })), 0)));

            if(localStorage.getItem("rol") == 'administrador' || (localStorage.getItem("user_id") == 1 || localStorage.getItem("user_id") == 9 || localStorage.getItem("user_id") == 10 || localStorage.getItem("user_id") == 13 || localStorage.getItem("user_id") == 8)){
     
                const { selectedDate, selectedDate_chofer } = this.state;

                let month = (selectedDate.getMonth() + 1).toString().padStart(2, "0"); 
                let year = selectedDate.getUTCFullYear();
                
                //let month_chofer = (selectedDate_chofer.getMonth() + 1).toString().padStart(2, "0"); 
                //let year_chofer = selectedDate_chofer.getUTCFullYear();
                
                const primerDiaSemana = format(
                startOfWeek(this.state.selectedDate_chofer, { weekStartsOn: 1 }),
                "yyyy-MM-dd"
              );
                  
                 axios.get('/checklist/graphic-checklist/'+year+'-'+month, {}).then((response) => {
                   if(response.data && response.data.dia){

                        let dataLineDiasEnex = [];
                        let dataLineActivosEnex = [];
                        let dataLineActivosEnex2 = [];
                        
                        let dataLineDiasEsmax = [];
                        let dataLineActivosEsmax = [];
                        let dataLineActivosEsmax2 = [];      

                        for(let i=0;i<response.data.dia.length;i++){
                            
                            dataLineDiasEnex.push(response.data.dia[i]);
                            dataLineActivosEnex.push(response.data.activasEnex[i]);
                            dataLineActivosEnex2.push(response.data.activasEnex2[i]);
   
                        }
                        
                        for(let i=0;i<response.data.diamax.length;i++){
                            dataLineDiasEsmax.push(response.data.diamax[i]);
                            dataLineActivosEsmax.push(response.data.activasEsmax[i]);
                            dataLineActivosEsmax2.push(response.data.activasEsmax2[i]);
                        }
                        
                        
                        this.setState({ loadingGrafico2 : false,
                          
                            dataLineActivosEnex:dataLineActivosEnex,
                            dataLineActivosEnex2:dataLineActivosEnex2,
                            totalEnex2: response.data.totalEnex2,
                            totalEnex: response.data.totalEnex,
                            dataLineDiasEnex : dataLineDiasEnex,
                            dataLineActivosEsmax:dataLineActivosEsmax,
                            dataLineActivosEsmax2:dataLineActivosEsmax2,
                            totalEsmax2: response.data.totalEsmax2,
                            totalEsmax: response.data.totalEsmax,
                            dataLineDiasEsmax : dataLineDiasEsmax,
                            totalEnexFinal: response.data.totalEnex2 + response.data.totalEnex,
                            totalEsmaxFinal: response.data.totalEsmax2 + response.data.totalEsmax,
                            DataDias: dataLineDiasEnex,
                            DataCombustible : dataLineActivosEnex,
                            DataLubricante: dataLineActivosEnex2,
                            totalEnexMask:response.data.totalEnex,
                            totalEnex2Mask:response.data.totalEnex2
                        });
                   } else {
                       this.setState({ loadingGrafico2 : false});  
                   }
                 }, (error) => {
                     console.log(error);
                     this.setState({ loadingGrafico2 : false});
                 });
                 
                  axios.get('/checklist/graphic-checklist-chofer/'+primerDiaSemana, {}).then((response) => {
                   if(response.data && response.data.dia){

                        let dataLineDiasEnex_chofer = [];
                        let dataLineActivosEnex_chofer = [];
                        let dataLineActivosEnex2_chofer = [];
                        
                        let dataLineDiasEsmax_chofer = [];
                        let dataLineActivosEsmax_chofer = [];
                        let dataLineActivosEsmax2_chofer = [];      

                        for(let i=0;i<response.data.dia.length;i++){
                            
                            dataLineDiasEnex_chofer.push(response.data.dia[i]);
                            dataLineActivosEnex_chofer.push(response.data.activasEnex[i]);
                            dataLineActivosEnex2_chofer.push(response.data.activasEnex2[i]);
   
                        }
                        
                        for(let i=0;i<response.data.diamax.length;i++){
                            dataLineDiasEsmax_chofer.push(response.data.diamax[i]);
                            dataLineActivosEsmax_chofer.push(response.data.activasEsmax[i]);
                            dataLineActivosEsmax2_chofer.push(response.data.activasEsmax2[i]);
                        }
                        
                        
                        this.setState({ loadingGrafico1 : false,
                          
                            dataLineActivosEnex_chofer:dataLineActivosEnex_chofer,
                            dataLineActivosEnex2_chofer:dataLineActivosEnex2_chofer,
                            totalEnex2_chofer: response.data.totalEnex2,
                            totalEnex_chofer: response.data.totalEnex,
                            dataLineDiasEnex_chofer : dataLineDiasEnex_chofer,
                            dataLineActivosEsmax_chofer:dataLineActivosEsmax_chofer,
                            dataLineActivosEsmax2_chofer:dataLineActivosEsmax2_chofer,
                            totalEsmax2_chofer: response.data.totalEsmax2,
                            totalEsmax_chofer: response.data.totalEsmax,
                            dataLineDiasEsmax_chofer : dataLineDiasEsmax_chofer,
                            totalEnexFinal_chofer: response.data.totalEnex2 + response.data.totalEnex,
                            totalEsmaxFinal_chofer: response.data.totalEsmax2 + response.data.totalEsmax,
                            DataDias_chofer: dataLineDiasEnex_chofer,
                            DataCombustible_chofer : dataLineActivosEnex_chofer,
                            DataLubricante_chofer: dataLineActivosEnex2_chofer,
                            totalEnexMask_chofer:response.data.totalEnex,
                            totalEnex2Mask_chofer:response.data.totalEnex2
                        });
                   } else {
                       this.setState({ loadingGrafico1 : false});  
                   }
                 }, (error) => {
                     console.log(error);
                     this.setState({ loadingGrafico1 : false});
                 });
             }
        }
        
        

         componentDidMount(){

         }

	render() {
                const {visible, selectedDate, selectedDate_chofer, loading, last_activity, myRol, loadingGrafico2, loadingGrafico1, maxDate, minDate,  maxDate_chofer, minDate_chofer, 
                    totalEnex,
                    totalEnexFinal,
                    totalEnex2, 
                    totalEsmax,
                    totalEsmaxFinal,
                    totalEsmax2,
                    activeEnex2,
                    activeEsmax2,
                    dataLineDiasEnex,
                    dataLineDiasEsmax, 
                    dataLineNuevosEnex,
                    dataLineNuevosEsmax, 
                    dataLineActivosEnex, 
                    dataLineActivosEnex2,
                    dataLineActivosEsmax, 
                    dataLineActivosEsmax2,
                    DataDias,
                    DataCombustible,
                    DataLubricante,
                    totalEnexMask,
                    totalEnex2Mask,
                    
                    totalEnex_chofer,
                    totalEnexFinal_chofer,
                    totalEnex2_chofer, 
                    totalEsmax_chofer,
                    totalEsmaxFinal_chofer,
                    totalEsmax2_chofer,
                    activeEnex2_chofer,
                    activeEsmax2_chofer,
                    dataLineDiasEnex_chofer,
                    dataLineDiasEsmax_chofer, 
                    dataLineNuevosEnex_chofer,
                    dataLineNuevosEsmax_chofer, 
                    dataLineActivosEnex_chofer, 
                    dataLineActivosEnex2_chofer,
                    dataLineActivosEsmax_chofer, 
                    dataLineActivosEsmax2_chofer,
                    DataDias_chofer,
                    DataCombustible_chofer,
                    DataLubricante_chofer,
                    totalEnexMask_chofer,
                    totalEnex2Mask_chofer,
                    openCalendar, weekRange
                } = this.state;
		const { match, darkMode } = this.props;
       
                const isDesktop = window.innerWidth > 768;
                
                const options = {
                
                maintainAspectRatio: true, 
                    responsive: true,
                    indexAxis: 'x',
                    plugins:{
                           legend: {
                               display:true,
                               position: "bottom",
                               title: { display: true, padding: 5 },
                               labels: {
                                   color: (darkMode === true ? 'white' : 'black'),
                                   generateLabels: (chart) => {
                                    const datasetLabels = chart.data.datasets.map((dataset, i) => ({
                                        text: i === 0 ? 'Combustible ('+totalEnexMask+')' : 'Lubricantes ('+totalEnex2Mask+')', // Cambia los textos de las leyendas
                                        fillStyle: dataset.backgroundColor,
                                        strokeStyle: dataset.borderColor,
                                        hidden: !chart.isDatasetVisible(i),
                                        lineCap: 'round',
                                        lineDash: [],
                                        lineDashOffset: 0,
                                        lineJoin: 'round',
                                        pointStyle: 'rect',
                                        rotation: 0,
                                        fontColor: (darkMode === true ? 'white' : 'black'),
                                        index: i,
                                        datasetIndex: i
                                    }));
                                    return datasetLabels;
                                    }
                               },
                                onHover: (event) => {
                                    event.native.target.style.cursor = 'pointer';
                                },
                                onLeave: (event) => {
                                    event.native.target.style.cursor = 'default';
                                }
                           },tooltip: {
                                  enabled: true,
                                  /*callbacks: {
                                    label: function(context) {
                                      return ' '+context.raw + '%';
                                    }
                                  }*/
                                },
                                 datalabels: {
                                    display: false,
                                  /*formatter: (value, context) => {
                                    return value+'%'; // o `${value}%` si quieres porcentaje
                                  },*/
                                    color: (darkMode === true ? 'white' : 'white'),
                                    font: {
                                        weight: 'bold',
                                      },
                                 },
                },    
                scales: {
                            x: {
                                    grid: {
                                            color: ChartConfig.chartGridColor,
                                            display:false
                                    },
                                    ticks: {
                                            fontColor: ChartConfig.axesColor,
                                            color: (darkMode === true ? 'white' : 'black')
                                    }
                            },
                            y: {
                                    grid: {
                                            color: ChartConfig.chartGridColor,
                                            display:false
                                    },
                                    ticks: {
                                            fontColor: ChartConfig.axesColor,
                                            color: (darkMode === true ? 'white' : 'black')
                                    }
                            },
                            
                    }
            }
            
            const options_chofer = {
                
                maintainAspectRatio: false, 
                    responsive: true,
                    indexAxis: 'x',
                    plugins:{
                           legend: {
                               display:true,
                               position: "bottom",
                               title: { display: true, padding: 5 },
                               labels: {
                                   color: (darkMode === true ? 'white' : 'black'),
                                   generateLabels: (chart) => {
                                    const datasetLabels = chart.data.datasets.map((dataset, i) => ({
                                        text: i === 0 ? 'Combustible ('+totalEnexMask_chofer+')' : 'Lubricantes ('+totalEnex2Mask_chofer+')', // Cambia los textos de las leyendas
                                        fillStyle: dataset.backgroundColor,
                                        strokeStyle: dataset.borderColor,
                                        hidden: !chart.isDatasetVisible(i),
                                        lineCap: 'round',
                                        lineDash: [],
                                        lineDashOffset: 0,
                                        lineJoin: 'round',
                                        pointStyle: 'rect',
                                        rotation: 0,
                                        fontColor: (darkMode === true ? 'white' : 'black'),
                                        index: i,
                                        datasetIndex: i
                                    }));
                                    return datasetLabels;
                                    }
                               },
                                onHover: (event) => {
                                    event.native.target.style.cursor = 'pointer';
                                },
                                onLeave: (event) => {
                                    event.native.target.style.cursor = 'default';
                                }
                           },
                           tooltip: {
                                  enabled: true,
                                  /*callbacks: {
                                    label: function(context) {
                                      return ' '+context.raw + '%';
                                    }
                                  }*/
                                },
                                 datalabels: {
                                    display: (context) => {
                                        const raw = context.dataset.data[context.dataIndex];
                                        const valor = Array.isArray(raw) ? raw[0] : raw;
                                        return valor !== 0 && valor !== "0" && valor != null;
                                       
                                      },
                                  /*formatter: (value, context) => {
                                    return value+'%'; // o `${value}%` si quieres porcentaje
                                  },*/
                                    color: (darkMode === true ? 'white' : 'white'),
                                    font: {
                                        weight: 'bold',
                                      },
                                 },
                },    
                scales: {
                            x: {
                                    grid: {
                                            color: ChartConfig.color.secondary,
                                            display: true,
                                            lineWidth: 1,
                                            drawTicks: false, 
                                            tickLength: 5,   
                                    },
                                    ticks: {
                                            fontColor: ChartConfig.axesColor,
                                            display: window.innerWidth > 768 ? true : false,
                                            color: (darkMode === true ? 'white' : 'black'),
                                            font: {
                                                 size: window.innerWidth > 768 ? 11 : 9
                                              },
                                            //maxRotation: 15,  // Ángulo máximo
                                            //minRotation: 15   // Ángulo mínimo (puedes poner 30 o 90 también)
                                    }
                            },
                            y: {
                                    grid: {
                                            color: ChartConfig.chartGridColor,
                                            display: true,
                                            lineWidth: 1,
                                            drawTicks: false, 
                                            tickLength: 1,   
                                    },
                                    ticks: {
                                            fontColor: ChartConfig.axesColor,
                                            color: (darkMode === true ? 'white' : 'black')
                                    }
                            },
                            
                    }
            }
            
            const data_chofer  = {
              labels: DataDias_chofer,
              datasets: [
                {
                  label: 'Combustible',
                  data: DataCombustible_chofer,
                  borderColor: ChartConfig.color.primary,
                  backgroundColor: ChartConfig.color.primary,
                  stack: 'combined',
                  type: 'bar',
                   barThickness: 50
                },
                {
                  label: 'Lubricantes',
                  data: DataLubricante_chofer,
                  borderColor: ChartConfig.color.warning,
                  backgroundColor: ChartConfig.color.warning,
                  stack: 'combined',
                  type: 'bar',
                   barThickness: 50
                }
              ]
            };

            const data  = {
              labels: DataDias,
              datasets: [
                {
                  label: 'Combustible',
                  data: DataCombustible,
                  borderColor: ChartConfig.color.primary,
                  backgroundColor: ChartConfig.color.primary,
                  stack: 'combined',
                  type: 'bar'
                },
                {
                  label: 'Lubricantes',
                  data: DataLubricante,
                  borderColor: ChartConfig.color.warning,
                  backgroundColor: ChartConfig.color.warning,
                  stack: 'combined',
                  type: 'bar'
                }
              ]
            };
               
		return (
                        
			<div className="ecom-dashboard-wrapper">
                                {loading  && 
                                    <RctSectionLoader />
				}
				<Helmet>
					<title>{process.env.MIX_APP_NAME} | Dashboard</title>
					<meta name="description" content="Dashboard" />
				</Helmet>
				<PageTitleBar title={<IntlMessages id="sidebar.dashboard" />} match={match} />
                                {!loading &&
                                <Fragment>
                                <Alert className="d-flex align-items-center" color="success" isOpen={this.state.visible} toggle={this.onDismiss}>
                                <i className="zmdi zmdi-check check-circle"></i> Última actividad registrada: {format(parseISO(last_activity), 'dd/MM/yyyy')} a las {format(parseISO(last_activity), 'H:mm')}
                                </Alert>
                                
                                 <Accordion  className="mb-30 panel" defaultExpanded>
                                        <AccordionSummary expandIcon={<i className="zmdi zmdi-chevron-down"></i>} className="m-0 panel-heading">
                                                <h4>Bienvenido</h4>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                                <p>
                                                       Sistema de Checklist para Transbenumapu, si detecta o experimenta algún problema favor enviar un mail a pablo.cruz@aysentf.cl o nikosk8r@gmail.com, o contáctese 
                                                       al número +56 9 88306126
                                                </p>
                                        </AccordionDetails>
                                </Accordion>
                                
                                <div className="row">
					
				<RctCollapsibleCard
                                        customClasses=""
                                        colClasses="col-sm-12 col-md-4 col-lg-4 w-xs-full"
                                        heading='Enlaces Rápidos'
                                        fullBlock
                                     >
                                    <RctCardContent>
                                        <FormControl  fullWidth > 
                                            <FormGroup>
                                                <MatButton  component={Link} to="/app/checklist/new" variant="contained" className="btn btn-block btn-warning mr-10 mb-10 text-white w-100">Ingresar Checklist</MatButton>
                                           </FormGroup>
                                           {myRol == 'administrador' &&
                                           <FormGroup>
                                                <MatButton component={Link} to="/app/users/user-management" variant="contained" className="btn btn-block btn-secondary mr-10 mb-10 text-white w-100">Gestión de Usuarios</MatButton>
                                            </FormGroup>
                                            }
                                        </FormControl>
                                     </RctCardContent>
                                    </RctCollapsibleCard>
                                    {(localStorage.getItem("user_id") == 1 || localStorage.getItem("user_id") == 9 || localStorage.getItem("user_id") == 13 || localStorage.getItem("user_id") == 8 || localStorage.getItem("user_id") == 10) &&
                                        <RctCollapsibleCard
                                        customClasses=""
                                        cardStyle={ isDesktop ? {height: '400px'} : ''}
                                        colClasses="col-sm-12 col-md-8 col-lg-8 w-xs-full"
                                        heading={'Checklist por Area'}
                                        onrefresh={this.onrefreshGraph2}
                                        fullBlock
                                     >
                                     {loadingGrafico2 ?
                                     <RctSectionLoader />
                                       : <RctCardContent>
                                       <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                              }}>
                                               <div style={{
                                                display: 'flex',
                                                alignItems: 'left',
                                                justifyContent: 'center',
                                                marginRight:'65px'
                                              }}>
                                               <MuiPickersUtilsProvider  locale={es} utils={DateFnsUtils}>
                                                        <DatePicker
                                                                views={['year', 'month']}
                                                                label="Selecciona periodo"
                                                                autoOk
                                                                showTabs={true}
                                                                dateformat="MM-YYYY"
                                                                maxDate={maxDate}
                                                                minDate={minDate}
                                                                value={selectedDate}
                                                                onChange={this.handleDateChange}
                                                                showmonthyearpicker="true"
                                                                leftArrowIcon={<i className="zmdi zmdi-arrow-back" />}
                                                                rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />}
                                                        />
                                                    </MuiPickersUtilsProvider>  
                                                    </div>
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                              }}>
                                              
                                             <Badge onClick={(e) => this.cambiaData2(e,'ENEX')} className="mb-10 mr-10 mt-10" color={activeEnex2 === '' ? 'primary': 'secondary'} style={{ cursor: 'pointer', textDecoration: activeEnex2 }} >ENEX ({totalEnexFinal})</Badge>
                                             <Badge onClick={(e) => this.cambiaData2(e,'ESMAX')} className="mb-10 mr-10 mt-10" color={activeEsmax2 === '' ? 'primary': 'secondary'} style={{ cursor: 'pointer', textDecoration: activeEsmax2 }} >ESMAX ({totalEsmaxFinal})</Badge>

                                            </div>
                                          </div>
                                        <FormControl   fullWidth >
                                            <Bar
                                                style={{ marginTop: '20px' }}
                                                type="line"
                                                width={160}
                                                height={35}
                                                options={options}
                                                data={data}
                                              />
                                        </FormControl>
                                        </RctCardContent> }
                                    </RctCollapsibleCard>
                                    }
                                    {(localStorage.getItem("user_id") == 1 || localStorage.getItem("user_id") == 9 || localStorage.getItem("user_id") == 13 || localStorage.getItem("user_id") == 8 || localStorage.getItem("user_id") == 10) &&
                                        <RctCollapsibleCard
                                        cardStyle={ isDesktop ? {height: '550px'} : ''}
                                        customClasses=""
                                        colClasses="col-sm-12 col-md-12 col-lg-12 w-xs-full"
                                        heading={'Checklist Semanal'}
                                        onrefresh={this.onrefreshGraph2_chofer}
                                        fullBlock
                                     >
                                     {loadingGrafico1 ?
                                        <RctSectionLoader />
                                       : <RctCardContent>
                                        <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                              }}>
                                               <div style={{
                                                display: 'flex',
                                                alignItems: 'left',
                                                justifyContent: 'center',
                                                marginRight:'65px'
                                              }}>
                                            <div>
                                                {/* input estilo DatePicker */}
                                                <TextField
                                                  label="Selecciona semana"
                                                  value={
                                                    weekRange[0] && weekRange[1]
                                                      ? `${format(weekRange[0], "dd/MM/yyyy")} al ${format(weekRange[1], "dd/MM/yyyy")}`
                                                      : ""
                                                    }
                                                  onClick={this.handleOpenCalendar}
                                                  fullWidth
                                                  readOnly
                                                />

                                                {/* Modal con calendario */}
                                                <Dialog open={openCalendar} onClose={this.handleCloseCalendar}>
                                                  <DialogContent>
                                                    <Calendar
                                                      onClickDay={this.handleChangeCalendar}
                                                      value={this.state.selectedDate_chofer}
                                                      maxDate={new Date()} 
                                                    />
                                                  </DialogContent>
                                                  <DialogActions>
                                                    <Button onClick={this.handleCloseCalendar}>Cancelar</Button>
                                                  </DialogActions>
                                                </Dialog>
                                              </div>
                                            </div>
                                        <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                              }}>
                                             <Badge onClick={(e) => this.cambiaData2_chofer(e,'ENEX')} className="mb-10 mr-10 mt-10" color={activeEnex2_chofer === '' ? 'primary': 'secondary'} style={{ cursor: 'pointer', textDecoration: activeEnex2_chofer }} >ENEX ({totalEnexFinal_chofer})</Badge>
                                             <Badge onClick={(e) => this.cambiaData2_chofer(e,'ESMAX')} className="mb-10 mr-10 mt-10" color={activeEsmax2_chofer === '' ? 'primary': 'secondary'} style={{ cursor: 'pointer', textDecoration: activeEsmax2_chofer }} >ESMAX ({totalEsmaxFinal_chofer})</Badge>

                                          </div>
                                          </div>
                                        <FormControl  fullWidth >
                                            <Bar style={{ marginTop: '30px' }}  width={160} height={isDesktop ? 35 : 280}  data={data_chofer} options={options_chofer} />
                                        </FormControl>
                                        </RctCardContent> }
                                    </RctCollapsibleCard>
                                    }
                                </div>
                                </Fragment>    
                                         
                                }
				
                        </div>
                     
		);
              }   
}

const mapStateToProps = ({ settings }) => {
	return settings;
};

export default connect(mapStateToProps, {})(Dashboard);
